'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _windBarbs = require('./windBarbs');

var _windBarbs2 = _interopRequireDefault(_windBarbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindBarbsLegend = function WindBarbsLegend() {
  return _react2.default.createElement(
    'div',
    { className: 'quiver-wind-barbs-legend' },
    _react2.default.createElement(
      'div',
      { className: 'quiver-wind-barbs-legend__example' },
      _react2.default.createElement(
        'p',
        { className: 'quiver-wind-barbs-legend__example__header' },
        'Read as:'
      ),
      _react2.default.createElement(
        'p',
        { className: 'quiver-wind-barbs-legend__example__label' },
        'NW wind at 20kts'
      ),
      _react2.default.createElement(
        'div',
        { className: 'quiver-wind-barbs-legend__example__icon' },
        _windBarbs2.default[4].icon
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'quiver-wind-barbs-legend__key' },
      _react2.default.createElement(
        'div',
        { className: 'quiver-wind-barbs-legend__key__header' },
        'Wind Speed & Direction (Barbs point to the direction the wind is coming from)'
      ),
      _react2.default.createElement(
        'div',
        { className: 'quiver-wind-barbs-legend__key__items' },
        _windBarbs2.default.map(function (item) {
          return _react2.default.createElement(
            'div',
            { key: item.label, className: 'quiver-wind-barbs-legend__key__item' },
            item.icon,
            item.label
          );
        })
      )
    )
  );
};

exports.default = WindBarbsLegend;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ChartLegend/WindBarbsLegend.js
// module id = 553
// module chunks = 11